import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Danhmucbenxe from "components/Danhmuc/Benxe/Danhmucbenxe.js";
export default function Dmbenxe() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Danh mục bến xe",
            tabContent: <Danhmucbenxe />,
          },
        ]}
      />
    </div>
  );
}
